import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=3f58ef20&scoped=true&"
import script from "./AppView.vue?vue&type=script&lang=ts&"
export * from "./AppView.vue?vue&type=script&lang=ts&"
import style0 from "./AppView.vue?vue&type=style&index=0&id=3f58ef20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f58ef20",
  null
  
)

export default component.exports